import React, { useState } from "react"
import { FaRegClipboard, FaCheck } from "react-icons/fa6"

interface CopyToClipboardProps {
  text: string
  successDuration?: number // optional: how long to show "Copied!" state (ms)
}

export const CopyToClipboard: React.FC<CopyToClipboardProps> = ({
  text,
  successDuration = 1500,
}: CopyToClipboardProps) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      setTimeout(() => setCopied(false), successDuration)
    } catch (err) {
      console.error("Failed to copy text: ", err)
    }
  }

  return (
    <button
      onClick={handleCopy}
      title={copied ? "Copied!" : "Copy to clipboard"}
      type="button"
      style={{
        cursor: "pointer",
        background: "none",
        border: "none",
        padding: 0,
        fontSize: "1.2rem",
        color: copied ? "green" : "inherit",
      }}
    >
      {copied ? <FaCheck /> : <FaRegClipboard />}
    </button>
  )
}
